import { useStoresApi } from '@/features/wizard';
import type { ILatLng, IMBEStore } from '@/types';
import type { SetStateAction, Dispatch } from 'react';
import { useCallback, useEffect, useState } from 'react';

export const useStores = (
  proximityParams: ILatLng
): {
  setVisibleStores: Dispatch<SetStateAction<IMBEStore[]>>;
  stores: IMBEStore[];
  visibleStores: IMBEStore[];
} => {
  const storesApi = useStoresApi();
  const [stores, setStores] = useState<IMBEStore[]>([]);
  const [visibleStores, setVisibleStores] = useState<IMBEStore[]>([]);

  const { lat, lng } = proximityParams;

  const fetch = useCallback(
    async (options?: RequestInit) => {
      try {
        const params = { nearLat: lat, nearLng: lng };
        const data = await storesApi.getAll(params, options);
        setStores(data);
      } catch (error) {
        // When abort() is called, the fetch() promise rejects with an Error of type DOMException, with name AbortError.
        if (!((error as DOMException).name === 'AbortError')) console.error(error);
        setStores([]);
      }
    },
    [lat, lng, storesApi]
  );

  useEffect(() => {
    const controller = new AbortController();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetch({ signal: controller.signal });

    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lat, lng, storesApi]);

  return { stores, visibleStores, setVisibleStores };
};
